import {ModalOptionDefault, Modal} from "../../Modals/Modal";

const css_classes = {
    nav_wrapper: 'ovolo-video-slider-player__nav',
    nav_arrow_prev: 'ovolo-video-slider-player__nav__arrow-prev',
    nav_arrow_next: 'ovolo-video-slider-player__nav__arrow-next',
    nav_title: 'ovolo-video-slider-player__nav__title',
    main_wrapper: 'ovolo-video-slider-player__main-wrapper'
};

declare var window: any;

interface VideoSliderPlayerOptionDefault {
    target_el: JQuery
}

const option_default: VideoSliderPlayerOptionDefault = {
    target_el: null
};

export class VideoSliderPlayer {

    option = option_default;
    
    video_player_el: JQuery = null;
    nav_el: JQuery = null;
    current_trigger_el: JQuery = null;

    constructor(option=option_default) {
        this.option = option;
    }

    init() {
        if (typeof jQuery === 'undefined') {
            return;
        }
        
        jQuery(($) => {
            $('.video-gallery-container .slide-background').on('click', (e) => {
                const trigger_el = jQuery(e.currentTarget);
                this.openPlayer(trigger_el);
            });
        });
    }

    refresh() {
        const video_name = this.current_trigger_el.siblings('p').find('strong').text();
        const video_location = this.current_trigger_el.siblings('p').find('span').text();
        this.nav_el.find(`.${css_classes.nav_title}`).html(`<div class="title-inner">${video_name} - ${video_location}</div>`);

        const video_link = this.current_trigger_el.data('videoLink');
        const video_id = window.ovolo.utils.getParameterByName('v', video_link);
        const video_url = `https://www.youtube.com/embed/${video_id}`;
        this.video_player_el.find('iframe').attr('src', video_url);
    }

    render(option_params = option_default) {
        const option = jQuery.extend(this.option, option_params);
        if (this.current_trigger_el === null || this.current_trigger_el.length === 0 || option.target_el === null) {
            console.error('Incorrect option');
            return;
        }
        const video_name = this.current_trigger_el.siblings('p').find('strong').text();
        const video_location = this.current_trigger_el.siblings('p').find('span').text();

        const nav_html = `<div class="${css_classes.nav_wrapper}">
                <div class="${css_classes.nav_arrow_prev}"><i class="icon-right-small"></i></div>
                <div class="${css_classes.nav_title}"><div class="title-inner">${video_name} - ${video_location}</div></div>
                <div class="${css_classes.nav_arrow_next}"><i class="icon-right-small"></i></div>
            </div>`;
        this.nav_el = jQuery(nav_html);
        this.nav_el.find(`.${css_classes.nav_arrow_prev}`).on('click', () => {
            const trigger_el = this.current_trigger_el.parents('.slick-slide').prev().find('> .slide-background');
            if (trigger_el.length) {
                this.current_trigger_el = trigger_el;
            } else {
                console.log(this.current_trigger_el.parents('.slick-slide').siblings(':last')[0]);
                this.current_trigger_el = this.current_trigger_el.parents('.slick-slide').siblings(':last').find('> .slide-background');
            }
            this.refresh();
        });
        this.nav_el.find(`.${css_classes.nav_arrow_next}`).on('click', () => {
            const trigger_el = this.current_trigger_el.parents('.slick-slide').next().find('> .slide-background');
            if (trigger_el.length) {
                this.current_trigger_el = trigger_el;
            } else {
                this.current_trigger_el = this.current_trigger_el.parents('.slick-slide').siblings(':first').find('> .slide-background');
            }
            this.refresh();
        });
        option.target_el.siblings('.ovolo-modal__modal__header').append(this.nav_el);

        const video_link = this.current_trigger_el.data('videoLink');
        const video_id = window.ovolo.utils.getParameterByName('v', video_link);
        const video_url = `https://www.youtube.com/embed/${video_id}`;

        const video_html = `<div class="${css_classes.main_wrapper}">
                <iframe src="${video_url}"
                title="YouTube video player" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>`;
        this.video_player_el = jQuery(video_html);

        option.target_el.append(this.video_player_el);

    }

    openPlayer(trigger_el: JQuery) {
        this.current_trigger_el = trigger_el;
        const modal_opt: ModalOptionDefault = {
            css_classes: 'ovolo-video-slider-player__dialog',
            create_callback: (modal_el: JQuery) => {
                const video_option = {
                    target_el: modal_el.find('.ovolo-modal__modal__body')
                };
                this.render(video_option);
            },
            close_callback: (modal_el: JQuery) => {
                modal_el.find('.ovolo-modal__modal__header').html('');
                modal_el.find('.ovolo-modal__modal__body').html('');
            }
        };
        const modal = new Modal(modal_opt);
        modal.open();
    }

}